import React, { Component } from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import Select from 'ps-components/ReactSelect/ReactSelect';

import './SetElementDropdown.scss';

class SetElementDropdown extends Component {
  static propTypes = {
    column: string,
    marketElements: arrayOf(
      shape({
        field_title: string,
        source_field: string
      })
    ),
    setElementValue: func,
    value: string
  };

  itemClickHandler = event => {
    const { column, setElementValue } = this.props;
    setElementValue(event, column);
  };

  render() {
    const { marketElements, value } = this.props;

    const options = marketElements.map(el => {
      return {
        value: el.field_title,
        label: el.field_title
      };
    });

    const selectedElement = value ? options.find(({ value: val }) => val === value) : null;

    return (
      <Select
        className="proposed-range-dropdown"
        options={options}
        clearable={false}
        value={selectedElement}
        onChange={this.itemClickHandler}
      />
    );
  }
}

export default SetElementDropdown;
